/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionBanContainer_story = {
    readonly site: {
        readonly id: string;
    };
    readonly " $refType": "ModerationActionBanContainer_story";
};
export type ModerationActionBanContainer_story$data = ModerationActionBanContainer_story;
export type ModerationActionBanContainer_story$key = {
    readonly " $data"?: ModerationActionBanContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionBanContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionBanContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '1436122d13ec12fd61ed2259b1d0aa2e';
export default node;
